import React, {FC, PropsWithChildren, useContext} from 'react';
import {AccordionContext} from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import {useAccordionButton} from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';
import {Markdown} from 'components/Markdown';

import PlusIcon from './svgs/plus.inline.svg';
import XMarkIcon from './svgs/xmark.inline.svg';

import * as styles from './styles.module.scss';

interface ToggleProps {
	open: boolean;
	onClick: React.EventHandler<React.SyntheticEvent>;
}

interface AccordionProps {
    eventKey: string;
	title: string;
	content: string;
}

const Toggle: FC<PropsWithChildren<ToggleProps>> = ({children, open, onClick}) => {
	const size = 18;
	return (
		<div className={styles.toggle} role='button' onClick={onClick}>
			<span>{children}</span>
			<div className={styles.icon}>
				{open ?
					<XMarkIcon width={size} height={size} /> :
					<PlusIcon width={size} height={size} />
				}
			</div>
		</div>
	);
};

const AccordionItem: FC<AccordionProps> = ({eventKey, title, content}) => {
	const {activeEventKey} = useContext(AccordionContext);
	const onClick = useAccordionButton(eventKey);
	const open = eventKey === activeEventKey;

	return (
		<Card>
			<Card.Header>
				<Toggle open={open} onClick={onClick}>
					{title}
				</Toggle>
			</Card.Header>
			<Accordion.Collapse eventKey={eventKey}>
				<Card.Body>
					<Markdown className={styles.markdown} markdown={content} />
				</Card.Body>
			</Accordion.Collapse>
		</Card>
	);
};

export default AccordionItem;
